import { ReactElement, useEffect, useState } from 'react';
import apiServices from '../services/apiServices';

interface Props {
  groupId: number;
  alt?: string;
  style?: any;
  onImageLoaded?: (blob: Blob) => void;
  altImg?: any;
}

function GroupIcon({ groupId, alt, style, onImageLoaded, altImg }: Props): ReactElement {
  const [imageUrl, setImageUrl] = useState<string>(altImg ? altImg : '');

  useEffect(() => {
    if (!groupId) {
      return
    }
    apiServices.getMemberGroupIcon(groupId).then(blob => {
      setImageUrl(URL.createObjectURL(blob));
      if (onImageLoaded) {
        onImageLoaded(blob);
      }
    }).catch(e => {
      setImageUrl(altImg ? altImg : '');
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]);

  return (
    <>
      {imageUrl ? <img src={imageUrl} alt={alt} style={style} /> : <span style={style}></span>}
    </>
  );
};

export default GroupIcon;
